import NumericInput from './numericInput';

export default NumericInput;
